import React from 'react';

import '../styles/auth.css';

interface ModalBackdropProps {
  onClick: () => void;
  isVisible: boolean;
  children?: React.ReactNode;
  className?: string;
}

export const ModalBackdrop: React.FC<ModalBackdropProps> = ({ onClick, isVisible, children, className }) => {
  if (!isVisible) return null;

  return (
    <div className={`auth-modal-backdrop ${className || ''}`} onClick={onClick}>
      {children}
    </div>
  );
};
